(() => {
  if (window.PlainJaneAreteCollection) return;
  window.PlainJaneAreteCollection = true;

  const syncFilterPanel = (section) => {
    if (!(section instanceof HTMLElement)) return;

    const open = section.classList.contains('is-filters-open');
    const toggle = section.querySelector('[data-pj-editorial-filter-toggle]');
    const panel = section.querySelector('.pj-arete-filter-panel');

    if (toggle instanceof HTMLButtonElement) toggle.setAttribute('aria-expanded', String(open));
    if (panel instanceof HTMLElement) panel.setAttribute('aria-hidden', String(!open));
  };

  const setFilterPanel = (section, open, returnFocus = false) => {
    if (!(section instanceof HTMLElement)) return;

    section.classList.toggle('is-filters-open', open);
    section.classList.remove('is-search-open');
    syncFilterPanel(section);
    syncSearch(section);

    if (returnFocus) {
      const toggle = section.querySelector('[data-pj-editorial-filter-toggle]');
      if (toggle instanceof HTMLButtonElement) toggle.focus({ preventScroll: true });
    }
  };

  const syncSearch = (section) => {
    if (!(section instanceof HTMLElement)) return;
    const open = section.classList.contains('is-search-open');
    const toggle = section.querySelector('[data-pj-editorial-search-toggle]');
    if (toggle instanceof HTMLButtonElement) toggle.setAttribute('aria-expanded', String(open));
  };

  const setSearch = (section, open) => {
    if (!(section instanceof HTMLElement)) return;

    section.classList.toggle('is-search-open', open);
    section.classList.remove('is-filters-open');
    syncSearch(section);
    syncFilterPanel(section);

    if (open) {
      const input = section.querySelector('[data-pj-editorial-search-input]');
      if (input instanceof HTMLInputElement) input.focus({ preventScroll: true });
    }
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const filterToggle = event.target.closest('[data-pj-editorial-filter-toggle]');
    if (filterToggle) {
      const section = filterToggle.closest('collection-section');
      if (section instanceof HTMLElement) {
        setFilterPanel(section, !section.classList.contains('is-filters-open'));
      }
      return;
    }

    const searchToggle = event.target.closest('[data-pj-editorial-search-toggle]');
    if (searchToggle) {
      const section = searchToggle.closest('collection-section');
      if (section instanceof HTMLElement) {
        setSearch(section, !section.classList.contains('is-search-open'));
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const section = document.querySelector('collection-section.is-filters-open, collection-section.is-search-open');
    if (!(section instanceof HTMLElement)) return;

    if (section.classList.contains('is-filters-open')) {
      setFilterPanel(section, false, true);
    } else {
      setSearch(section, false);
      const toggle = section.querySelector('[data-pj-editorial-search-toggle]');
      if (toggle instanceof HTMLButtonElement) toggle.focus({ preventScroll: true });
    }
  });

  document.addEventListener('section:updated', (event) => {
    const section = event.target instanceof Element ? event.target.closest('collection-section') : null;
    if (section instanceof HTMLElement) {
      syncFilterPanel(section);
      syncSearch(section);
    }
  });
})();
